<template>
  <!-- CHEYUWU 品牌圖示（2023，2026-10-04 起用在網站上）：內聯 SVG、currentColor，跟標誌（BrandLogo.vue）同一套做法。
       文字旁的記號，不取代文字 ⇒ 一律 aria-hidden。tight：viewBox 貼齊圖形外框（大標誌用）；預設保留 64 格的留白（跟文字並排時大小一致）。 -->
  <svg class="brand-icon" :class="'brand-icon-' + name" :viewBox="viewBox" fill="currentColor" aria-hidden="true" focusable="false">
    <path v-for="(d, i) in icon.paths" :key="i" :d="d" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { ICONS } from '@/runtime/brand-icons.mjs'

const props = defineProps({ name: { type: String, required: true }, tight: Boolean })
const icon = computed(() => ICONS[props.name] || { paths: [], box: [0, 0, 64, 64] })
const viewBox = computed(() => (props.tight ? icon.value.box.join(' ') : '0 0 64 64'))
</script>

<style>
.brand-icon { display: inline-block; width: 1.15em; height: 1.15em; flex: none; vertical-align: -0.2em; }
</style>
